<main class="merchandise_detail" v-if="order && merchandiseItem">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{ _(merchandiseItem.texts.title) }}</h1>
            <span class="icon back" @click="setCategory()"> chevron_left </span>
        </div>
    </header>
    <div id="background"></div>
    <merchandise-carousel
        :hasArrowButton="false"
        :clickable="false"
        :images="images"
        :lang="app.getLang()"
        v-if="images.length"
    >
    </merchandise-carousel>
    <div class="descriptions">
        <h2 class="title">{{ _(merchandiseItem.texts.catch_copy) }}</h2>
        <p style="white-space: pre-line">
            {{ _(merchandiseItem.texts.description) }}
        </p>
        <h3>
            {{ merchandiseItem.amountIncludingTax() | price }}
            <template v-if="_(merchandiseItem.texts.unit)">
                / {{ _(merchandiseItem.texts.unit) }}
            </template>
        </h3>
    </div>
    <hr />
    <div class="pulldown_row">
        <h3 class="talign_right">{{_('use_date')}}</h3>
        <div>
            <label class="wrap-input select">
                <select v-model="use_date" @change="changedUseDate()">
                    <option v-for="date in getDates()" :value="date">
                        {{ dateOption(date) }}
                    </option>
                </select>
            </label>
            <p v-if="!use_date" class="not_entered_alert">
                {{_('not_entered_alert')}}
            </p>
        </div>
    </div>
    <template v-if="merchandiseItem.sales_unit === 'quantity_unit'">
        <hr />
        <div class="pulldown_row">
            <h3 class="talign_right">{{_('offer_time')}}</h3>
            <label class="wrap-input select">
                <time-picker
                    v-model="order.start_time"
                    :selectable-times="getTimes()"
                />
            </label>
        </div>
    </template>
    <hr />
    <div class="pulldown_row">
        <h3 class="talign_right">{{_('per_room')}}</h3>
        <div>
            <label class="wrap-input select">
                <select
                    v-model="order.reserves_room_id"
                    @change="changedRoom()"
                >
                    <option
                        v-for="rr in availableReservesRooms()"
                        :value="rr.id"
                    >
                        {{_('room_count', rr.index)}} ({{_(rr.name)}})
                    </option>
                </select>
            </label>
            <p v-if="unselectableRoom()" class="not_entered_alert">
                {{_('please_select_your_room')}}
            </p>
        </div>
    </div>
    <template v-if="merchandiseItem.sales_unit === 'quantity_unit'">
        <hr />
        <div class="pulldown_row">
            <h3 class="talign_right">{{_('quantity')}}</h3>
            <div class="pulas_minus">
                <span class="icon minus" @click="reduceMerchandise"
                    >remove_circle_outline</span
                >
                <span class="merchandise_number"
                    >{{ order.quantity }}{{ _(merchandiseItem.texts.unit)
                    }}</span
                >
                <span class="icon pulas" @click="addMerchandise"
                    >add_circle</span
                >
            </div>
        </div>
    </template>

    <template
        v-if="merchandiseItem.user_defined_pulldown && merchandiseItem.user_defined_pulldown.options.length"
    >
        <hr />
        <div class="pulldown_row">
            <h3 class="talign_right user_defined">
                {{ merchandiseItem.user_defined_pulldown['title_' +
                app.getLang()] }}
            </h3>
            <label class="wrap-input select">
                <select v-model="order.select_answer">
                    <option
                        v-for="option in merchandiseItem.user_defined_pulldown.options"
                        :value="option.id"
                    >
                        {{ _(option) }}
                    </option>
                </select>
            </label>
        </div>
    </template>

    <template v-if="merchandiseItem.user_defined_textarea">
        <hr />
        <div class="pulldown_row">
            <h3
                class="talign_right user_defined"
                style="margin-bottom: 1rem; font-size: 1.08rem"
            >
                {{ merchandiseItem.user_defined_textarea['title_' +
                app.getLang()] }}
            </h3>
            <label class="wrap-input">
                <textarea v-model="order.text_answer"></textarea>
            </label>
        </div>
    </template>

    <template v-if="_(merchandiseItem.texts.notice)">
        <hr />
        <section class="remarks">
            <pre>{{ _(merchandiseItem.texts.notice) }}</pre>
        </section>
    </template>

    <template v-if="merchandiseItem.sales_unit === 'time_unit'">
        <hr />
        <div class="select_time_and_number">
            <h2 v-if="_(merchandiseItem.texts.purchase_guide)" class="title">
                {{ _(merchandiseItem.texts.purchase_guide) }}
            </h2>
            <h2 v-else class="title">{{ _('select_time_and_number') }}</h2>
            <p
                v-if="_(merchandiseItem.texts.cancel_description)"
                class="after_order_change"
            >
                {{ _(merchandiseItem.texts.cancel_description) }}
            </p>
            <p v-else class="after_order_change">
                {{ _('after_order_change') }}
            </p>
            <div
                class="card time_and_number-card"
                v-for="schedule in scheduleInUseDate()"
            >
                <label>
                    <input
                        type="radio"
                        name="country"
                        v-model="order.schedule_id"
                        :value="schedule.id"
                        @change="changeSchedule(schedule)"
                    />
                    <span
                        >{{ schedule.start_time }} ~ {{ schedule.end_time
                        }}</span
                    >
                </label>
                <div
                    class="pulas_minus"
                    :style="{'pointer-events': schedule.id === order.schedule_id ? '' : 'none'}"
                >
                    <span class="icon minus" @click="reduceMerchandise"
                        >remove_circle_outline</span
                    >

                    <span
                        class="merchandise_number"
                        v-if="schedule.id === order.schedule_id"
                        >{{ order.quantity }}{{ _(merchandiseItem.texts.unit)
                        }}</span
                    >
                    <span class="merchandise_number" v-else
                        >1{{ _(merchandiseItem.texts.unit) }}</span
                    >

                    <span class="icon pulas" @click="addMerchandise"
                        >add_circle</span
                    >
                </div>
            </div>
        </div>
    </template>

    <div id="cart-bar">
        <div class="cart-bar-content">
            <div class="cart-bar-el">
                <div class="cart_and_total_amount">
                    <span class="total_amount"
                        >{{ order.amount_including_tax | price }}</span
                    >
                    <span class="yen"></span>
                </div>
            </div>
            <button @click="addOrder()">{{_('add_to_cart')}}</button>
        </div>
    </div>
</main>
